"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SXFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_217)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_217`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.23999 0.000305176H35.76V23.9998H-0.23999V0.000305176Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M35.76 -0.00012207V11.7203L-0.23999 12.0122V-0.00012207H35.76Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.76 12.0005L-0.23999 24.0002V-0.00012207L17.76 12.0005Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.95217 12.0001C3.94353 12.107 3.93901 12.2141 3.9386 12.3214C3.9386 14.6291 5.80941 16.5 8.1172 16.5C10.425 16.5 12.2958 14.6292 12.2958 12.3214C12.2958 12.2132 12.2903 12.1062 12.2822 12.0001H3.95217Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.11752 10.0716C8.82762 10.0716 9.40326 9.49595 9.40326 8.78586C9.40326 8.07577 8.82762 7.50012 8.11752 7.50012C7.40743 7.50012 6.83179 8.07577 6.83179 8.78586C6.83179 9.49595 7.40743 10.0716 8.11752 10.0716Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.22437 8.46429V12.6429C5.22437 14.8573 8.11731 15.5358 8.11731 15.5358C8.11731 15.5358 11.0102 14.8573 11.0102 12.6429V8.46429H5.22437Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.1186 14.1901C7.58198 13.997 6.51013 13.5034 6.51013 12.6428V9.74988H9.72447V12.6428C9.7244 13.5063 8.65263 13.9987 8.1186 14.1901Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.76009 11.3571V10.7143L8.11715 10.3929L7.47435 10.7143V11.3571L7.15295 11.6786V12.9643H9.08149V11.6786L8.76009 11.3571Z",
					fill: "#F3F3F3"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_217`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SXFlag };
